import AgoraRTC, { IAgoraRTCClient, ILocalTrack } from "agora-rtc-sdk-ng"
import { config as AgoraCommunicationConfig } from "../../config"
import AgoraScreenManager from "./AgoraScreenManager"
import AgoraAudioManager from "./AgoraAudioManager"
import AgoraRegularManager from "./AgoraRegularManager"

export interface IAgoraManagerProps
{
    appId?: string
    channel?: string,
    token?: string,
    uid?: number | string | null
    audioOnly?: boolean
}

export type AgoraCustomManager = AgoraRegularManager | AgoraAudioManager | AgoraScreenManager

export type AgoraManagerType = "regular" | "audio" | "screen"

/**
 * Base agora class. This will be used as a template and will
 * store the agora clients, its data and its connection
 */
class AgoraManager implements IAgoraManagerProps
{
    /**
     * Application ID. 
     * This can be retrieved from the agora console
     */
    appId: string | undefined

    /**
     * Videocall channel name. 
     * This must be set by the application
     */
    channel: string | undefined
    
    /**
     * Token to access the channel as a participant. 
     * This must be retrieved from the videocall server API
     */
    token: string | undefined
    
    /**
     * Username
     */
    uid: number | string | undefined | null

    /**
     * Agora client. This handles the agora communication connection
     */
    client: IAgoraRTCClient | undefined
    
    constructor(props: IAgoraManagerProps)
    {
        this.appId = props.appId
        this.channel = props.channel
        this.token = props.token
        this.uid = props.uid
    }

    /**
     * Creates and stores an Agora client
     */
    initializeClient()
    {
        this.client = AgoraRTC.createClient(AgoraCommunicationConfig)
    }

    /**
     * Helper function to close and destroy a video/audio/camera track
     * @param track 
     */
    static destroyTrack(track: ILocalTrack)
    {
        track.close()
        track.removeAllListeners()
    }
}

export default AgoraManager
